var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "system_code",
    label: "システムコード",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "A"
    },
  },
  {
    id: "system_name",
    label: "システム名",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "B"
    },
  },

  {
    id: "company",
    label: "所管会社",
    type: types.SELECT_BOX4,
    // error_if_blank:true,
    page_controller:true,
    default_from_local_storage:"userCompany",
    api:"/master_company/list_company_name",
  },

  {
    id: "equipment_in_charge_department",
    label: "所管部署",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    api_uniq_grouping:true,
    sort_result:true,
    // error_if_blank:true,
    api: "/master_belongs/list_department",
    default_from_local_storage:"userDepartment",
    limit_department_on_search:false,
    limit_department_on_load:false,
    page_controller:true,
    // global_emit:"equipment_in_charge_department_selected",
    search_option:{
      define_department_limit_to_key:"system_jurisdiction_team"
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      master_system: "C",
    },
  },
  {
    id: "system_jurisdiction_team",
    label: "所管チーム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    api_uniq_grouping:true,
    sort_result:true,
    // error_if_blank:true,
    default_from_local_storage:"userTeam",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"team",
    limit_department_on_search:false,
    page_controller:true,
    search_option:{
      define_department_limit_by_key:"equipment_in_charge_department",
      api_field_name:"department",
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      master_system: "D"
    },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_master_system.js